import { makeGetRequest } from 'owa-ows-gateway';
import { WhoIsResponse } from '../contracts/whoIsResponse';
import { format } from 'owa-string-utils';
import store from '../store/store';

const getWhoIsDomainDetailsUrl: string = 'ows/api/v1/PremiumDomain/fetchwhois/?domainName={0}';

//Gets the whois response for the legacy premium domain
export async function getWhoIsDomainDetails(): Promise<WhoIsResponse> {
    let domainName = store.legacyPremiumTenant.TenantName;
    let response = await makeGetRequest(format(getWhoIsDomainDetailsUrl, domainName));
    return response;
}
